import React from "react";
import { highlight } from "../../general/search-highlight";

const DetailRow = ({ label, children, className = "" }) => (
  <div className={`ds-search-detail ${className}`.trim()}>
    <span className="ds-search-detail-label">{label}</span>
    <div className="ds-search-detail-content">{children}</div>
  </div>
);

export default function PaperSearchDetails({ paper, query }) {
  const articles = paper.articles || [];
  const hiddenArticleCount = Math.max(
    0,
    Number(paper.articleCount || articles.length) - articles.length,
  );

  return (
    <div className="ds-search-paper-details">
      {paper.snippet && (
        <DetailRow label="Justificare">
          {highlight(paper.snippet, query)}
        </DetailRow>
      )}

      {paper.motivationSnippet && (
        <DetailRow label="Motiv respingere">
          {highlight(paper.motivationSnippet, query)}
        </DetailRow>
      )}

      {articles.length > 0 && (
        <DetailRow label="Articole" className="ds-search-detail--articles">
          <div className="ds-search-article-list">
            {articles.map((article, index) => (
              <div className="ds-search-article" key={`${article.product}-${index}`}>
                <strong>{highlight(article.product, query)}</strong>
                {article.details && (
                  <span> — {highlight(article.details, query)}</span>
                )}
              </div>
            ))}
            {hiddenArticleCount > 0 && (
              <div className="ds-search-more-articles">
                + încă {hiddenArticleCount} articol
                {hiddenArticleCount === 1 ? "" : "e"}
              </div>
            )}
          </div>
        </DetailRow>
      )}
    </div>
  );
}
